export interface TermReqInterface {
  id?: number
  /**
   * 名称
   */
  name: string
  /**
   * 描述
   */
  description?: string
  /**
   * 父ID
   */
  parentId?: number
  schoolId?: number
  /**
   * 权重
   */
  weight?: number
  deletedAt?: string | null
}

export class TermReq implements TermReqInterface {
  id?: number
  /**
   * 名称
   */
  name: string
  /**
   * 描述
   */
  description?: string
  /**
   * 父ID
   */
  parentId?: number
  schoolId?: number
  /**
   * 权重
   */
  weight?: number
  deletedAt?: string | null

  constructor(props: TermReqInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      name: _name,
      description: _description,
      parentId: _parentId,
      schoolId: _schoolId,
      weight: _weight,
      deletedAt: _deletedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.name = _name
    this.description = _description
    this.parentId = _parentId
    this.schoolId = _schoolId
    this.weight = _weight
    this.deletedAt = _deletedAt
  }
}
